import { PagedResult } from '../../../shared/model/paged-result.model';
import { Image } from './image.model';

export class ImageSearchResult extends PagedResult {
  public Result: Array<Image>;

  public constructor() {
    super();

    this.Result = new Array<Image>();
  }
}
